import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ConfirmationModal,
  Text,
  TextButton,
  Tooltip,
  useOpenModal,
} from '@modusign/design-system';

export function ChangeToPublicLabelButton({
  needConfirm,
  onConfirm,
}: {
  needConfirm?: boolean;
  onConfirm: () => void;
}) {
  const openModal = useOpenModal();

  return (
    <Tooltip
      content={
        <Text textAlign="center">
          모든 멤버가 라벨을
          <br />
          이용할 수 있게 설정합니다.
        </Text>
      }
      placement="top-start"
    >
      <TextButton
        onClick={() => {
          if (needConfirm) {
            openModal(({ isOpen, onClose }) => (
              <ConfirmationModal
                confirmButtonLabel="변경"
                isOpen={isOpen}
                maxWidth="xs"
                title="라벨 보기 제한 해제"
                variant="warning"
                onClose={onClose}
                onConfirm={() => {
                  onConfirm();
                  onClose();
                }}
              >
                <Text as="p" textAlign="center">
                  모든 멤버가 이용할 수 있는 라벨로 변경할까요?
                  <br />
                  설정된 멤버·그룹은 초기화됩니다.
                </Text>
              </ConfirmationModal>
            ));
          } else {
            onConfirm();
          }
        }}
      >
        <FontAwesomeIcon icon={faEye} style={{ marginRight: '2px' }} />
        보기 제한 해제
      </TextButton>
    </Tooltip>
  );
}
